import {FC} from 'react';

type VoucherRemoveIcon = FC<{
  size?: number;
}>;

const VoucherRemoveIcon: VoucherRemoveIcon = ({size = 16}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9998 13.9998C11.3135 13.9998 13.9998 11.3135 13.9998 7.9998C13.9998 4.6861 11.3135 1.9998 7.9998 1.9998C4.6861 1.9998 1.9998 4.6861 1.9998 7.9998C1.9998 11.3135 4.6861 13.9998 7.9998 13.9998ZM7.9998 15.1998C11.9763 15.1998 15.1998 11.9763 15.1998 7.9998C15.1998 4.02335 11.9763 0.799805 7.9998 0.799805C4.02335 0.799805 0.799805 4.02335 0.799805 7.9998C0.799805 11.9763 4.02335 15.1998 7.9998 15.1998Z"
        fill="#8E8E8E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.15128 7.9998L3.97554 4.82407L4.82407 3.97554L7.9998 7.15128L11.1755 3.97554L12.0241 4.82407L8.84833 7.9998L12.0241 11.1755L11.1755 12.0241L7.9998 8.84833L4.82407 12.0241L3.97554 11.1755L7.15128 7.9998Z"
        fill="#8E8E8E"
      />
    </svg>
  );
};

export default VoucherRemoveIcon;
